import r from "./ghl-ui.es1245.js";
import s from "./ghl-ui.es1246.js";
function m(n, f, i) {
  (i !== void 0 && !s(n[f], i) || i === void 0 && !(f in n)) && r(n, f, i);
}
export {
  m as default
};
